module.exports = __webpack_public_path__ + "img/9c0c8d48714ab7b2bcbfdb607b22308b.jpg";